export default function ComplianceTravelerIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M32.1775 38.9483C28.3812 38.2282 24.4634 38.4994 20.8025 39.7358C17.6005 40.7754 14.6709 42.5167 12.2275 44.8326" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M12.2275 11.2969C16.4853 15.3345 22.1316 17.582 27.9994 17.575C33.8672 17.582 39.5135 15.3345 43.7713 11.2969" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M36.3567 28C36.3567 15.3125 32.6161 5.03125 28.0004 5.03125C23.3848 5.03125 19.6442 15.3125 19.6442 28C19.6193 31.902 20.0079 35.7956 20.8036 39.6156C22.2473 46.4188 24.9379 50.9688 28.0004 50.9688" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M38.4351 42.6016H50.9694V50.9578H38.4351V42.6016Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M44.7118 34.2656C45.8199 34.2656 46.8826 34.7058 47.6662 35.4894C48.4497 36.2729 48.8899 37.3356 48.8899 38.4437V42.6219H40.5337V38.4437C40.5337 37.3356 40.9739 36.2729 41.7574 35.4894C42.541 34.7058 43.6037 34.2656 44.7118 34.2656Z" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
      <path 
        d="M32.1781 50.5969C30.799 50.8429 29.4009 50.9673 28 50.9688C23.4572 50.9688 19.0164 49.6217 15.2393 47.0978C11.4621 44.574 8.5181 40.9868 6.77965 36.7898C5.0412 32.5928 4.58634 27.9745 5.4726 23.519C6.35885 19.0635 8.54641 14.9709 11.7587 11.7587C14.9709 8.54641 19.0635 6.35885 23.519 5.4726C27.9745 4.58634 32.5928 5.0412 36.7898 6.77965C40.9868 8.5181 44.574 11.4621 47.0978 15.2393C49.6217 19.0164 50.9688 23.4572 50.9688 28H5.03126" 
        stroke="#F71963" 
        strokeWidth="3.5" 
        strokeMiterlimit="10"
      />
    </svg>
  );
}
